module.exports = __webpack_public_path__ + "src/assets/img/musicbox-arm.b14962fb.png";